import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { RESET_CONFIG, SAVE_CONFIG } from 'redux/actionTypes/componentConfig';
import { initialPlotConfigStates } from 'redux/reducers/componentConfig/initialState';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { getHasPermissions } from 'redux/selectors';
import { permissions } from 'const';
var resetPlotConfig = function resetPlotConfig(experimentId, plotUuid, plotType) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var defaultConfig;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            defaultConfig = initialPlotConfigStates[plotType];
            _context.prev = 1;
            if (!getHasPermissions(null, permissions.WRITE)(getState())) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/plots/").concat(plotUuid), {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                config: defaultConfig
              })
            });
          case 5:
            dispatch({
              type: RESET_CONFIG,
              payload: {
                plotUuid: plotUuid,
                config: defaultConfig
              }
            });
            return _context.abrupt("return", defaultConfig);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            handleError(_context.t0, endUserMessages.ERROR_SAVING_PLOT_CONFIG);
            dispatch({
              type: SAVE_CONFIG,
              payload: {
                plotUuid: plotUuid,
                success: false
              }
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default resetPlotConfig;